import type { FC } from 'react';

import type { CardType } from '@shared/cards-types';
import { useAuthorizedCardsByProductId } from '@shared/cards-core';

import { CardTypeView } from './CardTypeView';

interface Props {
    productId: string;
    transactionCardId: string;
    transactionCardType: CardType;
}

export const AuthorizedCardType: FC<Props> = ({
    productId,
    transactionCardId,
    transactionCardType,
}) => {
    const { isPending, error, authorizedCards = [] } = useAuthorizedCardsByProductId(productId!);

    if (isPending || error) {
        return null;
    }

    const authorizedCard = authorizedCards.find(({ id }) => id === transactionCardId);

    return (
        <CardTypeView cardType={transactionCardType} cardHolderName={authorizedCard?.holderName} />
    );
};
